import { useState } from 'react'
import './Navbar.css'
import { Link, NavLink } from 'react-router-dom'
import { IoMenu } from 'react-icons/io5'
import MobileMenu from '../MobileMenu/MobileMenu'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'
import { useSiteContent } from '../../../context/SiteContentContext'
import { field, mediaSrc, numbered } from '../../../utils/cms'

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { navbar } = useSiteContent()
  const closeMenu = () => setMenuOpen(false)
  const openMenu = () => setMenuOpen(true)

  if (!navbar) return null

  const links = numbered(navbar, 'link', ['Label', 'Url'])
  const logo = mediaSrc(navbar, 'logo')
  const ctaLabel = field(navbar, 'ctaLabel')
  const ctaUrl = field(navbar, 'ctaUrl') || '/contact'
  const openMenuLabel = field(navbar, 'openMenuLabel')

  return (
    <>
      <div className="navbar-container">
        <div className="navbarwrapper">
          <div className="navbar">
            <Link className="navbar-left" to="/">
              {logo ? <img src={logo} alt="Tevris" className="navlogo" /> : null}
            </Link>

            <button
              type="button"
              className="navbar-toggle"
              onClick={openMenu}
              aria-expanded={menuOpen}
              aria-controls="mobile-menu"
              aria-label={openMenuLabel}
            >
              <IoMenu aria-hidden />
            </button>

            <div id="navbar-menu" className="navbar-menu">
              <nav className="navbar-center">
                {links.map(({ label, url, index }) => (
                  <NavLink
                    key={`${url}-${index}`}
                    className={({ isActive }) =>
                      `navlink${isActive ? ' navlink--active' : ''}`
                    }
                    to={url || '/'}
                    end={url === '/'}
                  >
                    {label}
                  </NavLink>
                ))}
              </nav>

              <div className="navbar-right">
                <LanguageSwitcher />
                <Link className="navbar-cta" to={ctaUrl}>
                  {ctaLabel}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MobileMenu
        isOpen={menuOpen}
        onClose={closeMenu}
        navbar={navbar}
        links={links}
        logo={logo}
        ctaLabel={ctaLabel}
        ctaUrl={ctaUrl}
      />
    </>
  )
}

export default Navbar
